export default "__VITE_ASSET__DvnKnjRB__"